import ApiService from "@/common/api.service";

export default {
  getCompanyUsers(id, data) {
    return ApiService.query(`admin/companies/${id}/users`, data);
  }
};
